import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import BookingPage from "@/components/BookingPage";
import AvailabilityPage from "@/components/AvailabilityPage";
import ClaimPage from "@/components/ClaimPage";
import EmbedPage from "@/components/EmbedPage";
import VolunteerPortal from "@/components/VolunteerPortal";
import RequesterPortal from "@/components/RequesterPortal";
import RequesterVerify from "@/components/RequesterVerify";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminDashboard from "@/components/admin/AdminDashboard";
import AdminBookings from "@/components/admin/AdminBookings";
import AdminVolunteers from "@/components/admin/AdminVolunteers";
import AdminSettings from "@/components/admin/AdminSettings";
import AdminEmailAdmin from "@/components/admin/AdminEmailAdmin";
import AdminEmbed from "@/components/admin/AdminEmbed";
import AdminVolunteerHours from "@/components/admin/AdminVolunteerHours";
import AdminTestimonials from "@/components/admin/AdminTestimonials";
import AdminSuperAdmin from "@/components/admin/AdminSuperAdmin";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminBookingCodes from "@/components/admin/AdminBookingCodes";
import AdminBookingArchives from "@/components/admin/AdminBookingArchives";
import AdminEmailLogs from "@/components/admin/AdminEmailLogs";
import "@/App.css";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("admin_token");
  if (!token) return <Navigate to="/admin" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BookingPage />} />
          <Route path="/availability" element={<AvailabilityPage />} />
          <Route path="/claim/:token" element={<ClaimPage />} />
          {/* Volunteer Portal Routes */}
          <Route path="/volunteer" element={<VolunteerPortal page="login" />} />
          <Route path="/volunteer/verify" element={<VolunteerPortal page="verify" />} />
          <Route path="/volunteer/dashboard" element={<VolunteerPortal page="dashboard" />} />
          <Route path="/my-bookings" element={<RequesterPortal />} />
          <Route path="/my-bookings/verify" element={<RequesterVerify />} />
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<ProtectedRoute><AdminLayout><AdminDashboard /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/bookings" element={<ProtectedRoute><AdminLayout><AdminBookings /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/volunteers" element={<ProtectedRoute><AdminLayout><AdminVolunteers /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute><AdminLayout><AdminSettings /></AdminLayout></ProtectedRoute>} />
          <Route path="/embed" element={<EmbedPage />} />
          <Route path="/admin/email-admin" element={<ProtectedRoute><AdminLayout><AdminEmailAdmin /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/embed" element={<ProtectedRoute><AdminLayout><AdminEmbed /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/volunteer-hours" element={<ProtectedRoute><AdminLayout><AdminVolunteerHours /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/testimonials" element={<ProtectedRoute><AdminLayout><AdminTestimonials /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/super-admin" element={<ProtectedRoute><AdminLayout><AdminSuperAdmin /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/booking-codes" element={<ProtectedRoute><AdminLayout><AdminBookingCodes /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/booking-archives" element={<ProtectedRoute><AdminLayout><AdminBookingArchives /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/email-logs" element={<ProtectedRoute><AdminLayout><AdminEmailLogs /></AdminLayout></ProtectedRoute>} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
